"use client";

import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

interface SliderProps
  extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  setPrice?: React.Dispatch<React.SetStateAction<number>>;
  client?: string;
  locale?: string;
}

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, ...props }, ref) => {
  function convertToArabicNumbers(input: string | number): string {
    const englishToArabicMap: { [key: string]: string } = {
      "0": "٠",
      "1": "١",
      "2": "٢",
      "3": "٣",
      "4": "٤",
      "5": "٥",
      "6": "٦",
      "7": "٧",
      "8": "٨",
      "9": "٩",
    };

    return input
      .toString()
      .split("")
      .map((char) => englishToArabicMap[char] || char)
      .join("");
  }

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none select-none items-center",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary/70">
        <SliderPrimitive.Range className="absolute h-full bg-secondary" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb name="slider" aria-hidden="true" className="relative block h-5 w-5 rounded-full border-2 border-primary bg-secondary ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
        <span
          dir={props.locale === "ar" ? "rtl" : "ltr"}
          className="absolute flex text-black justify-center items-center rounded-md w-20 h-8 bg-background -top-10 left-1/2 -translate-x-1/2"
        >
          {(() => {
            const currentValue = props.value?.[0] ?? props.defaultValue?.[0] ?? "";
            return props.locale === "ar"
              ? convertToArabicNumbers(currentValue.toString())
              : currentValue;
          })()}
          <span
  aria-hidden="true"
  className="absolute border-4 border-transparent border-t-background bottom-0 left-1/2 -translate-x-1/2 translate-y-full"
></span>
        </span>
      </SliderPrimitive.Thumb>
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
